import {ActionReducer, ActionReducerMap, MetaReducer} from '@ngrx/store';
import {environment} from '../../../environments/environment';
import {AppState} from '../states/app.state';
import {initialJfLibState, jfLibReducers} from '@adnova/jf-ng-components';
import {firmaEntitiesReducer, initialFirmaEntitiesState} from './firma-entities.reducers';
import {initialLandEntitiesState, landEntitiesReducer} from './land-entities.reducers';
import {finanzamtEntitiesReducer, initialFinanzamtEntitiesState} from './finanzamt-entities.reducers';
import {firmaEditReducer, initialFirmaEditState} from './firma-edit.reducers';
import {appContextReducer, initialAppContextState} from './app-context.reducers';
import {exportConfigEntitiesInitialState, exportConfigEntitiesReducer} from './export-config-entities.reducers';


export const initialAppState: AppState = {
  ...initialJfLibState,
  firmaEntities: initialFirmaEntitiesState,
  landEntities: initialLandEntitiesState,
  finanzamtEntities: initialFinanzamtEntitiesState,
  firmaEdit: initialFirmaEditState,
  appContext: initialAppContextState,
  exportConfigEntities: exportConfigEntitiesInitialState,
};

export const reducers: ActionReducerMap<AppState> = {
  ...jfLibReducers,
  firmaEntities: firmaEntitiesReducer,
  landEntities: landEntitiesReducer,
  finanzamtEntities: finanzamtEntitiesReducer,
  firmaEdit: firmaEditReducer,
  appContext: appContextReducer,
  exportConfigEntities: exportConfigEntitiesReducer,
};

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [logger] : [];
